import { Component } from '@angular/core'
import { AirbnbCategoryRatingItem } from '@tokeet-frontend/channels'
import * as lodash from 'lodash'
import { BookingReviewBaseComponent } from '../booking-review-base'
import { DataCheckerService, Toaster } from '@tokeet-frontend/tv3-platform'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { DataDictService } from '@tv3/services/data-dict.service'
import { ReviewService } from '@tokeet-frontend/reviews'
import { ReviewAirbnbGuestDialogService } from '../../review-airbnb-guest-dialog/review-airbnb-guest-dialog.service'

@Component({
  selector: 'app-airbnb-booking-review',
  templateUrl: './airbnb-booking-review.component.html',
  styleUrls: ['./airbnb-booking-review.component.scss'],
})
export class AirbnbBookingReviewComponent extends BookingReviewBaseComponent {
  constructor(
    fb: FormBuilder,
    store: Store<any>,
    reviewService: ReviewService,
    toaster: Toaster,
    dataDictService: DataDictService,
    dataChecker: DataCheckerService,
    private reviewAirbnbGuestDialog: ReviewAirbnbGuestDialogService
  ) {
    super(fb, store, reviewService, toaster, dataDictService, dataChecker)
  }

  getCategoryTags(item: AirbnbCategoryRatingItem) {
    return lodash
      .map(item.review_category_tags, (t) => t.replace(/(guest|host)_review_(host|guest)_(negative|positive)_/i, ''))
      .map((t) => lodash.capitalize(lodash.startCase(t)))
      .join(', ')
  }

  onReviewGuest() {
    this.reviewAirbnbGuestDialog.open(this.inquiry).subscribe(() => {
      this.loadReviews()
    })
  }
}
